/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RemoveTeamMemberRequest = {
  orgId: string;
  teamId: string;
  memberId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/**
 * OK
 */
export type RemoveTeamMemberResponseBody = {
  id: string;
  deleted: boolean;
};

/** @internal */
export const RemoveTeamMemberRequest$inboundSchema: z.ZodType<
  RemoveTeamMemberRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  orgId: z.string(),
  teamId: z.string(),
  memberId: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type RemoveTeamMemberRequest$Outbound = {
  orgId: string;
  teamId: string;
  memberId: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const RemoveTeamMemberRequest$outboundSchema: z.ZodType<
  RemoveTeamMemberRequest$Outbound,
  z.ZodTypeDef,
  RemoveTeamMemberRequest
> = z.object({
  orgId: z.string(),
  teamId: z.string(),
  memberId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function removeTeamMemberRequestToJSON(
  removeTeamMemberRequest: RemoveTeamMemberRequest,
): string {
  return JSON.stringify(
    RemoveTeamMemberRequest$outboundSchema.parse(removeTeamMemberRequest),
  );
}
export function removeTeamMemberRequestFromJSON(
  jsonString: string,
): SafeParseResult<RemoveTeamMemberRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RemoveTeamMemberRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RemoveTeamMemberRequest' from JSON`,
  );
}

/** @internal */
export const RemoveTeamMemberResponseBody$inboundSchema: z.ZodType<
  RemoveTeamMemberResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  deleted: z.boolean(),
});
/** @internal */
export type RemoveTeamMemberResponseBody$Outbound = {
  id: string;
  deleted: boolean;
};

/** @internal */
export const RemoveTeamMemberResponseBody$outboundSchema: z.ZodType<
  RemoveTeamMemberResponseBody$Outbound,
  z.ZodTypeDef,
  RemoveTeamMemberResponseBody
> = z.object({
  id: z.string(),
  deleted: z.boolean(),
});

export function removeTeamMemberResponseBodyToJSON(
  removeTeamMemberResponseBody: RemoveTeamMemberResponseBody,
): string {
  return JSON.stringify(
    RemoveTeamMemberResponseBody$outboundSchema.parse(
      removeTeamMemberResponseBody,
    ),
  );
}
export function removeTeamMemberResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<RemoveTeamMemberResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RemoveTeamMemberResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RemoveTeamMemberResponseBody' from JSON`,
  );
}
